import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
export function PricingSection() {
  const [selectedOption, setSelectedOption] = useState('elite');
  const options = [{
    id: 'base',
    title: 'Pack Base',
    desc: 'Pack principal + 2 bonos estratégicos',
    icon: '📋',
    price: 19990,
    oldPrice: '$49.975 ARS',
    savings: 'Ahorrás 60%',
    url: 'https://checkout.nuvoraplus.online/cart/53229091651952:1',
    oldPriceValue: 49975
  }, {
    id: 'atlas',
    title: 'Pack + Atlas de Selección',
    desc: 'Pack principal + 2 bonos + Atlas de Selección: Matriz de Decisiones Técnicas',
    icon: '🗺️',
    price: 25990,
    oldPrice: '$64.975 ARS',
    savings: 'Ahorrás 60%',
    url: 'https://checkout.nuvoraplus.online/cart/53346361606512:1',
    oldPriceValue: 64975
  }, {
    id: 'protocolos',
    title: 'Pack + Protocolos de Comunicación',
    desc: 'Pack principal + 2 bonos + Protocolos de Comunicación: El Guión del Profesional de Élite',
    icon: '🎙️',
    price: 25990,
    oldPrice: '$64.975 ARS',
    savings: 'Ahorrás 60%',
    url: 'https://checkout.nuvoraplus.online/cart/53346362524016:1',
    oldPriceValue: 64975
  }, {
    id: 'elite',
    title: 'Pack Élite',
    desc: 'Pack principal + 2 bonos + Atlas de Selección + Protocolos de Comunicación',
    icon: '🏆',
    price: 28990,
    oldPrice: '$72.475 ARS',
    savings: 'Ahorrás 60%',
    url: 'https://checkout.nuvoraplus.online/cart/53346292040048:1',
    oldPriceValue: 72475,
    isBest: true,
    savingsAmount: 'AHORRÁS 60%'
  }];
  const selectedData = options.find(opt => opt.id === selectedOption) || options[3];
  const handleCheckoutClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: selectedData.title,
        content_type: 'product',
        value: selectedData.price,
        currency: 'ARS'
      });
      window.fbq('track', 'InitiateCheckout', {
        content_name: selectedData.title,
        value: selectedData.price,
        currency: 'ARS'
      });
    }
  };
  return <section id="precio" className="py-12 bg-background-dark relative overflow-hidden" data-id="element-216">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-217">
        <FadeIn className="text-center mb-12" data-id="element-218">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white font-heading mb-2" data-id="element-219">
            Elegí tu
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary font-heading mb-6 notranslate" translate="no" data-id="element-220">
            Pack:
          </h3>
          <p className="text-xl text-gray-400" data-id="element-221">
            Todas las opciones incluyen los 2 bonos estratégicos
          </p>
        </FadeIn>

        <div className="space-y-4 mb-10" data-id="element-222">
          {options.map((opt, index) => <FadeIn key={opt.id} delay={0.1 * index} direction="up" data-id="element-223">
              <div onClick={() => setSelectedOption(opt.id)} className={`
                  relative cursor-pointer rounded-2xl p-5 md:p-6 transition-all duration-300
                  border-2 flex flex-col md:flex-row items-start md:items-center gap-4
                  ${selectedOption === opt.id ? 'bg-card-dark border-primary shadow-[0_0_20px_rgba(255,107,0,0.15)]' : 'bg-card-dark border-card-border-dark hover:border-primary/50'}
                `} data-id="element-224">
                {opt.isBest && <>
                    <div className="absolute -top-3 left-4 bg-primary text-black text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full shadow-lg z-10" data-id="element-225">
                      🏆 MÁS ELEGIDO
                    </div>
                    <div className="absolute -top-3 right-4 bg-primary text-black text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full shadow-lg z-10 hidden sm:block" data-id="element-226">
                      {opt.savingsAmount}
                    </div>
                  </>}

                <div className="flex items-center gap-4 flex-1" data-id="element-227">
                  <div className={`
                    w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-all
                    ${selectedOption === opt.id ? 'border-primary' : 'border-gray-500'}
                  `} data-id="element-228">
                    {selectedOption === opt.id && <div className="w-3 h-3 rounded-full bg-primary" data-id="element-229" />}
                  </div>

                  <div className="text-2xl shrink-0" data-id="element-230">{opt.icon}</div>

                  <div data-id="element-231">
                    <h4 className="text-lg md:text-xl font-bold text-white mb-1" data-id="element-232">
                      {opt.title}
                    </h4>
                    <p className="text-sm text-gray-400 leading-relaxed" data-id="element-233">
                      {opt.desc}
                    </p>
                  </div>
                </div>

                <div className="flex flex-row md:flex-col items-center md:items-end justify-between w-full md:w-auto mt-4 md:mt-0 pt-4 md:pt-0 border-t border-card-border-dark md:border-t-0" data-id="element-234">
                  <div className="flex flex-col items-start md:items-end" data-id="element-235">
                    <span className="text-gray-500 line-through text-sm mb-1 notranslate" translate="no" data-id="element-236">
                      {opt.oldPrice}
                    </span>
                    <span className={`text-2xl md:text-3xl font-black notranslate ${selectedOption === opt.id ? 'text-primary' : 'text-white'}`} translate="no" data-id="element-237">
                      ${opt.price.toLocaleString('es-AR')} ARS
                    </span>
                  </div>
                  <span className="bg-primary/20 text-primary px-3 py-1 rounded-full text-xs font-bold mt-2" data-id="element-238">
                    {opt.savings}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-239">
          <div className="bg-card-dark border border-card-border-dark rounded-2xl p-6 md:p-8 mb-8" data-id="element-240">
            <div className="flex flex-col items-center justify-center text-center gap-2" data-id="element-241">
              <span className="text-gray-500 line-through text-lg md:text-xl font-bold notranslate" translate="no" data-id="element-242">
                VALOR TOTAL REAL: {selectedData.oldPrice}
              </span>
              <span className="text-white font-bold text-xl md:text-2xl mt-2" data-id="element-243">
                HOY PAGÁS SOLO:
              </span>
              <span className="text-5xl md:text-6xl font-black text-primary font-heading mt-2 notranslate" translate="no" data-id="element-244">
                ${selectedData.price.toLocaleString('es-AR')} ARS
              </span>
            </div>
          </div>

          <div id="checkout-btn" className="flex flex-col items-center gap-6" data-id="element-245">
            <Button fullWidth href={selectedData.url} className="md:py-6 md:text-2xl max-w-xl mx-auto" onClick={handleCheckoutClick} data-id="element-246">
              💪 → COMPLETAR MI PEDIDO AHORA
            </Button>

            <p className="text-gray-500 text-sm italic text-center max-w-md" data-id="element-247">
              El pago se realiza a través de Mercado Pago.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-gray-400" data-id="element-248">
              <span data-id="element-249">🔒 Pago seguro</span>
              <span data-id="element-250">⚡ Acceso en 5 minutos</span>
              <span data-id="element-251">🛡️ Garantía 7 días sin preguntas</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}